import React from 'react';
import {TableRow, TableRowColumn} from 'material-ui/Table';

export default function UserRow(props) {
  return (
    <TableRow key={props.user._id}>
      <TableRowColumn style={{whiteSpace: 'normal'}}>
        {props.user.fullName}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.user.emailAddress}
      </TableRowColumn>
      <TableRowColumn style={{whiteSpace:'normal'}}>
        {props.user.isAdmin ? "Kyllä" : "Ei"}
      </TableRowColumn>
    </TableRow>
  );
}



// WEBPACK FOOTER //
// ./src/components/UsersPage/UserRow.js